<template>
    <div class="ticket __card">
        <div class="__icon">
            <img :src="icon">
        </div>
        <div class="__ticket">
            <div class="__title">
                {{ title }}
            </div>
            <div class="__desc">{{ description }}</div>
            <div class="__cost">{{ formatCost( cost ) }}</div>
            <div class="__options">
                <ul>
                    <li v-for="( str, index ) in options" 
                        :key="index"
                        class="plus"
                        >{{ str }}
                    </li>
                </ul>
            </div>
            <div v-if="buyKey" class="__bay">
                <button
                    @click="$emit('eventClickBuy')"
                    :disabled=true
                >Купить</button>
            </div>
        </div>
        <div v-if="count" class="__baner">
            <span>Осталось</span><br>
            <span>
                {{ count }} билета
            </span>
        </div>
    </div>
</template>
<script>
import ticket from '@/assets/ticket.svg';
export default {
    name: 'ElemTicket',
    components: {},
    props: {
        title: String,
        description: String,
        cost: Number,
        options: Object,
        buyKey: {
            type: Boolean,
            default: () => false,
        },
        count: Number,
    },
    data() {
        return {
            icon: ticket,
        }
    },
    mounted() {
    },
    methods: {
        formatCost: function(value) {
            return Intl.NumberFormat('ru-RU', { 
                style: 'currency',
                currency: 'RUB',
                maximumFractionDigits: 0,
            }).format( value )
        },
    }
}
</script>
<style lang="scss">
$pri: #45289C;
$sec: #1E9BD8;
$tre: #290a4f;
$text-color: #C0B8C9;
.ticket{
    &.__card{
        position: relative;
        border: solid 1px rgb(83, 83, 83);
        border-radius: 25px;
        color: #fff;
        text-align: left;
        display: flex;
        padding: 5px 5px 5px 5px;
        background-image: radial-gradient(circle at 134% -36%, #1E9BD8 0%, transparent 61%), radial-gradient(circle at 69% 71%, #290A4F 3%, transparent 41%);
        .__icon{
            // flex-basis: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 5px;
            @media ( min-width: 768px ) {
                width: 100px;
            }
            img{
                height: 60px;
                width: 60px;
            }
            border-right: dotted 2px #fff;
        }
        .__ticket{
            padding: 5px 10px 10px 5px;
            flex-grow: 1;
            padding-left: 10px;
        }
        .__title{
            font-size: 2em;
            font-weight: 700;
            text-transform: capitalize;
            margin-bottom: .5em;
        }
        .__cost{
            color: $sec;
            font-size: 2em;
            font-weight: 600;
            margin-bottom: .3em;
        }
        .__baner{
            display: none;
            position: absolute;
            top: -10px;
            right: -1px;
            font-size: .85em;
            @media ( min-width: 992px ) {
                right: -8px;
                font-size: .85em;
            }
            background: $tre;
            background-image: linear-gradient( 66deg, $pri, $tre);
            padding: 5px 15px;
            border-radius: 10px;
        }
        .__bay{
            text-align: end;
            button{
                background: #1E9BD8;
                border-radius: 50px;
                border: none;
                color: #fff;
                padding: 10px 24px;
                cursor: pointer;
                &:disabled{
                    background: #50bbf555;
                    color: #b8b8b892;
                    cursor: auto;
                }
            }
        }
        
    }
}
</style>